// ** React Imports
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import {
    Autocomplete,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Fab,
} from '@mui/material'
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import { SyntheticEvent, useEffect, useState } from 'react';
import { getGudangJadi } from '../../../../api/helper';

export default function Add() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const navigate = useNavigate();

    const [openWorkOrderDialog, setOpenWorkOrderDialog] = useState<boolean>(false)
    const [listWorkOrder, setListWorkOrder] = useState<any[]>([])  
    const [listGudang, setListGudang] = useState<any[]>([])
    const [valGudang, setValGudang] = useState<any>(null)

    interface FormInputs {
        syscabang_id: any,
        tgl: any,
        keterangan: any,
        pic: any,
        work_order: any,
        work_order_id: any,
        mmgudang_id: any,
    }

    const defaultValues = {
        syscabang_id: cabang,
        tgl: new Date(new Date().getTime() + (7 * 60 * 60 * 1000)).toISOString().substring(0, 16),
    }

    const handleChangeAutocompleteGudang = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmgudang_id', newValue ? newValue.id : null)
        setValGudang(newValue.nama )
    }

    const customRender = [
        {
            key: "link",
            renderCell: (row: any) =>
                row.link ? (
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                            e.stopPropagation(); // cegah rowClick
                            setOpenWorkOrderDialog(false);
                            Swal.fire({
                                title: 'Preview Gambar',
                                html: `<img src="${row.link}" alt="Gambar" style="max-width:100%;max-height:400px;" />`,
                                showCloseButton: true,
                                showConfirmButton: true,
                                confirmButtonText: 'OK',
                                width: 600,
                            }).then(result => {
                                if (result.isConfirmed) {
                                    setOpenWorkOrderDialog(true);
                                }
                            });
                        }}
                    >
                        <Icon icon="mdi:search" fontSize={20} />
                        View Image
                    </Button>
                ) : (
                    <Icon icon="mdi:close-circle-outline" fontSize={24} color="grey" />
                ),
        }
    ];
    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    useEffect(() => {
         const fetchGudang = async () => {
            const response = await getGudangJadi(token);
            setListGudang(response);
        };
        fetchGudang();
    }, [])

    const getWorkOrder = () => {
        axios.get(apiUrl.apiUrl + '/production/bhp/list-open-wo', {
            headers: { Authorization: `Bearer ${token}` }
        }).then(response => {
            if (response.data.success) {
                setListWorkOrder(response.data.data)
            }
        }).catch(error => {
            console.log(error)
        })
    }

    const rowClickWorkOrder = (e: any) => {
        const data = e.data
        setValue('work_order_id', data?.id)
        setValue('work_order', data?.id + ' - ' + data?.sku)
        setOpenWorkOrderDialog(false)
    }

    const onSubmit = (data: any) => {
        if(getValues('work_order_id') == null){
            Swal.fire({
                title: 'Pemberitahuan',
                text: 'Work Order harus diisi',
                icon: 'warning'
            })
            return
        }

        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/production/bhp/add'
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    navigate('/production/bhp/detail/' + response.data.data)
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Buat BHP
                    </Typography>
                    <Divider sx={{ m: 0 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3} sx={{ mt: 1 }}>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valGudang}
                                        options={listGudang}
                                        id='gudang'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteGudang}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Gudang'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='datetime-local'
                                                value={value}
                                                label='Tanggal'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.tgl)}
                                            />
                                        )}
                                    />
                                    {errors.tgl && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Tanggal harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={5} sm={5}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='work_order'
                                        control={control}
                                        render={({ field: { value } }) => (
                                            <TextField
                                                label='Work Order'
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            
                            <Grid item xs={12} md={1} sm={1} sx={{ display: 'flex', alignItems: 'center' }}>
                                <Fab color='info' size='medium' onClick={() => {
                                    getWorkOrder();
                                    setOpenWorkOrderDialog(true);
                                }}
                                >
                                    <Icon icon='mdi:search' fontSize={35} color='white' />
                                </Fab>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='pic'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='PIC'
                                                onChange={onChange}
                                                error={Boolean(errors.pic)}
                                            />
                                        )}
                                    />
                                    {errors.pic && (
                                        <FormHelperText sx={{ color: 'error.main' }}>PIC harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                onChange={onChange}
                                                multiline
                                                rows={4}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>
            <Dialog
                maxWidth={'xl'}
                fullWidth={true}
                open={openWorkOrderDialog}
                onClose={() => setOpenWorkOrderDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        List Work Order
                    </Typography>
                </DialogTitle>
                <DialogContent  dividers sx={{ p: 4 }}>
                    <Grid container spacing={4}>
                        <MsiDatagrid array={listWorkOrder} rowClick={rowClickWorkOrder} customRender={customRender} hiddenColumns={['proses','barang_jadi']} />
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenWorkOrderDialog(false)}>Batal</Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}
